/**
 * Calcula el dígito de validación para un RUC de Panamá
 * @param {boolean} oldRuc - Indica si es un RUC antiguo
 * @param {string} ructb - La cadena de RUC sin el dígito de validación
 * @returns {string} - El dígito de validación calculado
 */
function calculate (oldRuc, ructb) {
  let j = 2
  let nsuma = 0

  // Procesar la cadena en orden inverso
  for (let i = ructb.length - 1; i >= 0; i--) {
    const c = ructb[i]

    if (oldRuc && j === 12) {
      oldRuc = false
      j -= 1
    }

    nsuma += j * (c.charCodeAt(0) - '0'.charCodeAt(0))
    j += 1
  }

  const r = nsuma % 11
  return r > 1 ? String(11 - r) : '0'
}


/**
 * Clase para validar y calcular el dígito de validación de un RUC Jurídica de Panamá
 */
class RucJuridica {
  rolloTomo;
  folioImagen;
  asientoFicha;

  _validateRucInput (ruc) {
    ruc = ruc.replace(/\s/g, '').toUpperCase()

    const dashCount = (ruc.match(/-/g) || []).length
    if (dashCount > 3 || dashCount < 2 || ruc.length < 5) {
      return false
    }

    const rucParts = ruc.split('-')

    if (rucParts.length !== 3) {
      return false
    }

    const rolloTomo = rucParts[0]
    const folioImagen = rucParts[1]
    const asientoFicha = rucParts[2]

    if (!/^\d+$/.test(rolloTomo) || rolloTomo.length > 9) {
      // Formato RUC invalido
      return false
    }

    if (!/^\d+$/.test(folioImagen) || folioImagen.length > 4) {
      // Formato RUC invalido
      return false
    }

    if (!/^\d+$/.test(asientoFicha) || asientoFicha.length > 6) {
      // Formato RUC invalido
      return false
    }

    this.ruc = ruc
    this.rolloTomo = rolloTomo
    this.folioImagen = folioImagen
    this.asientoFicha = asientoFicha
  }

  _calculateDv (ruc) {
    this._validateRucInput(ruc)
    let ructb = this.rolloTomo.padStart(10, '0') +
      this.folioImagen.padStart(4, '0') +
      this.asientoFicha.padStart(6, '0')

    if (ructb[3] === '0' && ructb[4] === '0' && ructb[5] < '5') {
      this.isRucAntiguo = true
      // Referencia cruzada requerida para RUCs Antiguos
      const crossRefKey = ructb.substring(5, 7)
      const crossRefValue = OLD_RUC_CROSS_REF[crossRefKey] || crossRefKey
      ructb = ructb.substring(0, 5) + crossRefValue + ructb.substring(7)
    } else {
      this.isRucAntiguo = false
    }

    const dv1 = calculate(this.isRucAntiguo, ructb)
    const dv2 = calculate(this.isRucAntiguo, ructb + dv1)

    return dv1 + dv2
  }
}
// Tabla de referencia cruzada para RUC antiguos
const OLD_RUC_CROSS_REF = {
  '00': '00',
  '10': '01',
  '11': '02',
  '12': '03',
  '13': '04',
  '14': '05',
  '15': '06',
  '16': '07',
  '17': '08',
  '18': '09',
  '19': '01',
  '20': '02',
  '21': '03',
  '22': '04',
  '23': '07',
  '24': '08',
  '25': '09',
  '26': '02',
  '27': '03',
  '28': '04',
  '29': '05',
  '30': '06',
  '31': '07',
  '32': '08',
  '33': '09',
  '34': '01',
  '35': '02',
  '36': '03',
  '37': '04',
  '38': '05',
  '39': '06',
  '40': '07',
  '41': '08',
  '42': '09',
  '43': '01',
  '44': '02',
  '45': '03',
  '46': '04',
  '47': '05',
  '48': '06',
  '49': '07'
}

export { RucJuridica }



// WEBPACK FOOTER //
// ./src/utils/validationPanama.js